import { AfterViewInit, Component, ElementRef, ViewChild, input } from '@angular/core';

/**
 * "You're done" message for the terminal screens that tell the customer their part is finished: the workflow-completed
 * status and waiting-for-signatures (KOR-15211, Figma 8280:7006).
 *
 * The heading takes focus on arrival rather than living in a live region: it mounts with its text in one change-detection
 * pass and never changes, so role="status" would never fire, and Angular does not announce route changes - focus is what
 * makes the message reach a screen reader (decision carried over from LX-658 / KOR-15053).
 */
@Component({
  selector: 'app-completion-message',
  templateUrl: './completion-message.component.html',
  styleUrls: ['./completion-message.component.scss'],
  standalone: true,
})
export class CompletionMessageComponent implements AfterViewInit {
  heading = input.required<string>();

  message = input.required<string>();

  @ViewChild('headingElement') headingElement?: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.headingElement?.nativeElement.focus();
  }
}
